import 'css-chunksrc/client/common/projectSection/project/portfolioList/portfolio/styles.scss';export default {
  "tag": "_tag_3pidg_1",
  "name": "_name_3pidg_15",
  "removeIconBox": "_removeIconBox_3pidg_23",
  "removeIcon": "_removeIcon_3pidg_23"
};